// extracted by mini-css-extract-plugin
export default {"dialog-layout":"dialog-layout--3itRI","dialog-layout__content":"dialog-layout__content--WHIKJ"};
    if(module.hot) {
      // 1747648180720
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  